import { c as _c } from "react/compiler-runtime";
import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import cn from "twsx";

// Keyboard hints (Figma "Kbd"): inline text in menus, boxed in tooltips and
// comboboxes, taller in the command palette. Chords sit 3px apart.
const kbdVariants = cva("inline-flex items-center justify-center font-sans text-xs text-text-tertiary", {
  variants: {
    variant: {
      inline: "font-medium",
      box: "h-[19px] min-w-4.5 rounded-kbd border border-border-subtle px-0.75 leading-[13px]",
      palette: "h-[23px] min-w-5 rounded-checkbox border border-border-subtle px-1 font-[450]"
    }
  },
  defaultVariants: {
    variant: "box"
  }
});
export type KbdProps = VariantProps<typeof kbdVariants> & {
  keys: string | string[];
  className?: string;
};

/** Use when showing a keyboard shortcut. */
export function Kbd(t0) {
  const $ = _c(12);
  const {
    keys,
    variant,
    className
  } = t0;
  let t1;
  if ($[0] !== keys) {
    t1 = Array.isArray(keys) ? keys : [keys];
    $[0] = keys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const list = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("inline-flex items-center gap-0.75", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== list || $[5] !== variant) {
    let t4;
    if ($[7] !== variant) {
      t4 = (key, index) => <kbd key={`${key}-${index}`} className={kbdVariants({
        variant
      })}>{key}</kbd>;
      $[7] = variant;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = list.map(t4);
    $[4] = list;
    $[5] = variant;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}